// extracted by mini-css-extract-plugin
export default {"carouselContainer":"carousel_carouselContainer__9391O","carouselContainerNoTilt":"carousel_carouselContainerNoTilt__W5CCF"};